import {Platforms} from '@app/core-shared';

export const platformEnumOptions = [
  { value: null, label: 'core-shared.shared.platforms.0' },
  { value: Platforms.Android, label: 'core-shared.shared.platforms.2' },
  { value: Platforms.IOS, label: 'core-shared.shared.platforms.1' }
];

